import { $Q, $Qll } from '../utils/query-selector';
import { debounce } from 'lodash';

/**
 * Shows a validation message for the input
 *
 * @param {"value"|"empty"} reason - reason the message needs to be shown
 */
const showInputValidationMessage = (reason) => {
  const messageContainer = $Q('.main-product-surmesure__error');
  messageContainer.classList.remove('hidden');

  messageContainer.innerHTML = messageContainer.dataset[`${reason}Message`];
};

const hideInputValidationMessage = () => {
  $Q('.main-product-surmesure__error').classList.add('hidden');
};

/**
 * Validates the value of the input and shows appropriate message
 *
 * @param {HTMLElement} element - input value to validate
 */
export const validateInputValue = (element) => {
  const inputValue = Number(element.value);
  const min = Number(element.min);
  const max = Number(element.max);

  if (inputValue < min) {
    return false;
  }

  if (inputValue > max) {
    return false;
  }

  if (inputValue >= min && inputValue <= max) {
    return true;
  }

  return true;
};

/**
 * Validate all surmesure inputs
 */
const validateAllInputs = () => {
  const lstSurmesureInputs = $Qll('.main-product-surmesure__inputs input');
  const btnCart = $Q('.btn-cart-js');
  let statusInput = true;

  lstSurmesureInputs.forEach((input) => {
    if (!validateInputValue(input)) {
      statusInput = false;
    }
  });

  if (statusInput) {
    hideInputValidationMessage();
    if (btnCart.innerHTML !== btnCart.dataset.notAvailableMessage) {
      btnCart.disabled = false;
    }
  } else {
    showInputValidationMessage('value');
    btnCart.disabled = true;
  }
}

const handleInputChange = (e) => {
  validateInputValue(e.target);
  validateAllInputs();
};

const handleVariantInputChange = (e) => {
  const target = e.target ? e.target : e;
  const container = target.closest('.main-product__surmesure');
  const options = JSON.parse(container.dataset.options);

  const sizeOption = options.find(
    (option) => option.name.toLowerCase() === 'taille',
  );

  const sizeValues = sizeOption.values.map((val) => parseInt(val, 10)).sort();

  /* console.log(
    'these are the values for the taille',
    sizeValues,
    sizeOption.values,
  ); */

  let selectedVariant = sizeValues.find(
    (value) => value >= Number(target.value),
  );

  //console.log('selected variant is', selectedVariant);

  if (!selectedVariant) {
    selectedVariant = sizeValues[sizeValues.length - 1];
  }

  selectedVariant = selectedVariant.toString();

  // get all the inputs for the size or taille option
  const sizeInputs = $Qll('[data-option="Taille"] input');

  sizeInputs.forEach((size) => {
    if (size.value === selectedVariant) {
      // eslint-disable-next-line no-param-reassign
      size.checked = true;

      if (selectedVariant !== container.dataset.selectedVariant) {
        container.setAttribute('data-selected-variant', selectedVariant);
        size.dispatchEvent(new Event('change', size));
        validateAllInputs();
      }
    } else {
      size.removeAttribute('checked');
    }
  });
};

export const initializeMeasureInputs = () => {
  const measureInputs = $Qll('.main-product-surmesure__inputs input');

  measureInputs.forEach((input) =>
    input.addEventListener('input', handleInputChange),
  );

  const firstInput = measureInputs[0];

  firstInput.addEventListener(
    'input',
    debounce(handleVariantInputChange, 1500),
  );
};

export const changeInputValue = () => {
  document.addEventListener("DOMContentLoaded", () => {
    const form = $Q('#main-product-form');

    form.reset();
  })
}
